import React, { useState } from 'react'
import { Card, CardContent } from '../../ui/card'
import { Button } from '../../ui/button'
import { Label } from '../../ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select'
import { Loader2 } from 'lucide-react'
import { toast } from 'sonner'
import { extractErrorMessage } from '@/common/extractErrorMessage'
import { useApplicationStore } from '../../../stores/useApplicationStore'
import ReportEndpoints from '../../../endpoints/ReportEndpoints'
import { ReportViewer, useReportViewer } from '../ReportViewer'
import { rootUrl } from '../reportShared'

export const IdentityByClientPage: React.FC = () => {
  const { clients } = useApplicationStore()
  const { viewerProps, openReport, generating, setGenerating } = useReportViewer()

  const [clientId, setClientId] = useState<string>('0')
  const [sort, setSort] = useState<string>('lastName')

  const generate = async () => {
    setGenerating(true)
    try {
      const res = await ReportEndpoints.getIdentityExportByClientReport({
        clientId: parseInt(clientId), sort, rootUrl,
      })
      openReport('Identity Export by Client', res, parseInt(clientId) > 0 ? parseInt(clientId) : null)
    } catch (error) { toast.error(extractErrorMessage(error, 'Failed to generate report')) }
    finally { setGenerating(false) }
  }

  return (
    <>
      <Card className="max-w-3xl">
        <CardContent className="pt-6 space-y-4">
          <div className="space-y-2">
            <Label>Client *</Label>
            <Select value={clientId} onValueChange={setClientId}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="0">All Clients</SelectItem>
                <SelectItem value="-1">Global (No Client)</SelectItem>
                {clients.filter((c) => !c.dateArchived).map((c) => (
                  <SelectItem key={c.id} value={c.id.toString()}>{c.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Sort By</Label>
            <Select value={sort} onValueChange={setSort}>
              <SelectTrigger className="w-[200px]"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="lastName">Last Name</SelectItem>
                <SelectItem value="dateModified">Date Modified</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Button onClick={generate} disabled={generating}>
            {generating ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Generating...</> : 'Generate Report'}
          </Button>
        </CardContent>
      </Card>
      <ReportViewer {...viewerProps} />
    </>
  )
}
